import type { AuthenticationCredential } from '@column/api';

import type { PublicKeyCredentialRequestOptionsJSON } from '~/lib/webauthn/client';

import { client } from './client';
import { STEP_UP_REQUIRED_ERROR_CODE } from './client/Client';

export { STEP_UP_REQUIRED_ERROR_CODE } from './client/Client';

export enum StepUpChallenge {
  MfaSms = 'CHALLENGE_MFA_SMS',
  MfaTotp = 'CHALLENGE_MFA_TOTP',
  Password = 'CHALLENGE_PASSWORD',
  Webauthn = 'CHALLENGE_WEBAUTHN',
}

export type StepUpBeginResponse = {
  challengeName: StepUpChallenge;
  // Set only for CHALLENGE_WEBAUTHN. The challenge id itself is not here by design: the server returns it in
  // an HttpOnly cookie so script cannot read it, and finish reads it from that cookie.
  options?: PublicKeyCredentialRequestOptionsJSON;
};

export type StepUpFinishRequest = {
  code?: string;
  password?: string;
  credential?: AuthenticationCredential;
};

export const isStepUpRequiredError = (error: unknown): boolean =>
  typeof error === 'object' && error !== null && (error as { code?: unknown }).code === STEP_UP_REQUIRED_ERROR_CODE;

export class StepUpRepository {
  static async begin() {
    return client.post<object, StepUpBeginResponse>('/dashboard/step-up/begin', {}, { sandbox: true });
  }

  static async finish(request: StepUpFinishRequest) {
    // rawBody: a WebAuthn assertion's keys are case-sensitive and must not be snake_cased.
    return client.post<StepUpFinishRequest, object>('/dashboard/step-up/finish', request, {
      rawBody: true,
      sandbox: true,
    });
  }
}
